import { createContext, useContext } from "react";
import type { PostHogInterface } from "posthog-js";

export type PostHogContextValue = {
  client: PostHogInterface | null;
  flagsRevision: number;
};

export const PostHogContext = createContext<PostHogContextValue>({
  client: null,
  flagsRevision: 0,
});

export const usePostHog = () => useContext(PostHogContext).client ?? undefined;

export const useFeatureFlagEnabled = (flag?: string) => {
  const { client, flagsRevision } = useContext(PostHogContext);
  void flagsRevision;

  if (!flag) {
    return true;
  }

  // Keep gated UI visible until PostHog loads so the sidebar does not flash away.
  if (!client) {
    return true;
  }

  return client.isFeatureEnabled(flag) ?? true;
};
